import { CloudRoom } from '@shure/cloud/shared/models/devices';

import { CloudRoomFragment } from '../graphql/generated/cloud-sys-api';

export function mapCloudRoomFromSysApi(cloudRoom: CloudRoomFragment | null | undefined): CloudRoom | undefined {
	if (!cloudRoom) {
		return undefined;
	}

	return {
		id: cloudRoom.id,
		name: cloudRoom.name,
		groupId: cloudRoom.group?.id,
		health: cloudRoom.health.worstSeverity ?? undefined
	};
}
